/* src/app/modules_v2/booking/availability/components/location-vacations/location-vacations.component.css */
.vacations-container {
  padding: 20px;
}
h3 {
  color: var(--cf-chrome);
  margin-bottom: 16px;
}
/*# sourceMappingURL=location-vacations.component.css.map */
